import { render, staticRenderFns } from "./MalKabul.vue?vue&type=template&id=5e3d41d0&"
import script from "./MalKabul.vue?vue&type=script&lang=js&"
export * from "./MalKabul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports